import initialState from '../store/initial-state'

import {
  GET_TRASH_ITEMS,
  GET_TRASH_ITEMS_SUCCESS,
  GET_TRASH_ITEMS_FAILURE,
  CLEAR_ALL_TRASH,
  CLEAR_ALL_TRASH_SUCCESS,
  CLEAR_ALL_TRASH_FAILURE,
  RESTORE_ASSETS,
  RESTORE_ASSETS_SUCCESS,
  RESTORE_ASSETS_FAILURE,
  DELETE_ASSETS,
  DELETE_ASSETS_SUCCESS,
  DELETE_ASSETS_FAILURE,
  MOVE_ASSETS,
  MOVE_ASSETS_SUCCESS,
  MOVE_ASSETS_FAILURE,
  DOWNLOAD_ASSETS,
  DOWNLOAD_ASSETS_SUCCESS,
  DOWNLOAD_ASSETS_FAILURE,
  GET_TRASH_USAGE_LIST,
  GET_TRASH_USAGE_LIST_SUCCESS,
  GET_TRASH_USAGE_LIST_FAILURE
} from '../constants/trash-types'

export default (state = initialState.trash, action) => {
  switch (action.type) {
    case GET_TRASH_ITEMS:
      return {
        ...state,
        loadingTrashItems: true,
        errorTrashItems: false,
      }
    case GET_TRASH_ITEMS_SUCCESS:
      return {
        ...state,
        loadingTrashItems: false,
        errorTrashItems: false,
        trashItems: action.payload.items
      }
    case GET_TRASH_ITEMS_FAILURE:
      return {
        ...state,
        loadingTrashItems: false,
        errorTrashItems: true,
        trashItems: [],
      }
    //ASSETS QUANTITY REDUCER
    case GET_TRASH_USAGE_LIST:
      return {
        ...state,
        loadingTrashUsageList: true,
        errorTrashUsageList: false,
      }
    case GET_TRASH_USAGE_LIST_SUCCESS:
      return {
        ...state,
        loadingTrashUsageList: false,
        errorTrashUsageList: false,
        trashUsageList: action.payload.assetList,
        totalAssets: action.payload.totalAssets
      }
    case GET_TRASH_USAGE_LIST_FAILURE:
      return {
        ...state,
        loadingTrashUsageList: false,
        errorTrashUsageList: true,
        trashUsageList: [],
        totalAssets: 0
      }
    case CLEAR_ALL_TRASH:
      return {
        ...state,
        loadingClearAllTrash: true,
        errorClearAllTrash: false,
      }
    case CLEAR_ALL_TRASH_SUCCESS:
      return {
        ...state,
        loadingClearAllTrash: false,
        errorClearAllTrash: false,
      }
    case CLEAR_ALL_TRASH_FAILURE:
      return {
        ...state,
        loadingClearAllTrash: false,
        errorClearAllTrash: true,
      }
    case RESTORE_ASSETS:
      return {
        ...state,
        loadingRestoreAssets: true,
        errorRestoreAssets: false,
      }
    case RESTORE_ASSETS_SUCCESS:
      return {
        ...state,
        loadingRestoreAssets: false,
        errorRestoreAssets: false,
      }
    case RESTORE_ASSETS_FAILURE:
      return {
        ...state,
        loadingRestoreAssets: false,
        errorRestoreAssets: true,
      }
    case DELETE_ASSETS:
      return {
        ...state,
        loadingDeleteAssets: true,
        errorDeleteAssets: false,
      }
    case DELETE_ASSETS_SUCCESS:
      return {
        ...state,
        loadingDeleteAssets: false,
        errorDeleteAssets: false,
      }
    case DELETE_ASSETS_FAILURE:
      return {
        ...state,
        loadingDeleteAssets: false,
        errorDeleteAssets: true,
      }
    case MOVE_ASSETS:
      return {
        ...state,
        loadingMoveAssets: true,
        errorMoveAssets: false,
      }
    case MOVE_ASSETS_SUCCESS:
      return {
        ...state,
        loadingMoveAssets: false,
        errorMoveAssets: false,
      }
    case MOVE_ASSETS_FAILURE:
      return {
        ...state,
        loadingMoveAssets: false,
        errorMoveAssets: true,
      }
    case DOWNLOAD_ASSETS:
      return {
        ...state,
        loadingDownloadAssets: true,
        errorDownloadAssets: false,
      }
    case DOWNLOAD_ASSETS_SUCCESS:
      return {
        ...state,
        loadingDownloadAssets: false,
        errorDownloadAssets: false,
      }
    case DOWNLOAD_ASSETS_FAILURE:
      return {
        ...state,
        loadingDownloadAssets: false,
        errorDownloadAssets: true,
      }
    default: return { ...state }
  }
}
